<template>
  <div class="input-address-with-map">
    <div class="input-address-container">
      <span
        v-if="showGuide == false"
        class="label-description"
      >
        GPS 출석체크 목적으로 건물 정보까지 입력하시면 됩니다.
      </span>
      <el-input
        v-model="value"
        class="input-address"
        placeholder="센터 주소를 검색해주세요"
        :disabled="true"
      />
      <div 
        class="unvisible-search-address-trigger" 
        @click="searchAddress"
      />

      <el-button
        class="btn-search-address"
        @click="searchAddress"
      >
        검색
      </el-button>

      <span
        v-if="showGuide == true"
        class="label-description"
        style="line-height: 33px;"
      >
        GPS 출석체크 목적으로 건물 정보까지 입력하시면 됩니다.
      </span>
    </div>

    <div
      v-show="showMobileAddressView"
      class="mobile-address-view-container"
    >
      <div
        id="wrap"
        ref="mobileAddressView"
        class="mobile-address-view"
      />
    </div>

    <div
      class="map-view"
      ref="mapViewRef"
      v-map-view="{address: value, isMapShow : mapVisible}"
      @center-change="onCenterChange"
    />
  </div>
</template>

<script>
import mapView from '@/directives/MapView.js';
import { detectDevicePlatform } from '../utils/etc';

export default {
  name: 'AddressInputWithMap',
  directives: { mapView },
  data() {
    return {
      value: '',
      coordinate: {
        latitude: null,
        longitude: null
      },
      showMobileAddressView: false
    };
  },
  created() {
    this.$on('centerChange', this.onCenterChange);
  },
  mounted() {
    this.isMobileMapVisibleClassSet();
  },
  props: {
    showGuide: {
      type: Boolean,
      default: false
    },
    address: {
      type: String,
      default: ''
    },
    mapVisible: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    address: {
      immediate: true,
      handler(newAddress) {
        this.value = newAddress;
      }
    }
  },
  methods: {
    isMobileMapVisibleClassSet() {
      if (!this.mapVisible) {
        this.$refs.mapViewRef.classList.add('map-hidden');
      }
    },
    closeMobileAddressView() {
      this.showMobileAddressView = false;
    },
    openPostcodePopupWindow() {
      new window.daum.Postcode({
        oncomplete: data => {
          this.value = this.makeFullAddress(data);
        }
      }).open();
    },
    openPostcodeMobileInlineView() {
      const currentScroll = Math.max(
        document.body.scrollTop,
        document.documentElement.scrollTop
      );

      new window.daum.Postcode({
        oncomplete: data => {
          this.value = this.makeFullAddress(data);
          document.body.scrollTop = currentScroll;
          this.closeMobileAddressView();
        },
        onresize: size => {
          this.$refs.mobileAddressView.style.height = size.height + 'px';
        },
        width: '100%',
        height: '300px'
      }).embed(this.$refs.mobileAddressView);

      this.showMobileAddressView = true;
    },
    searchAddress() {
      if (detectDevicePlatform() != null) {
        this.openPostcodeMobileInlineView();
      } else {
        this.openPostcodePopupWindow();
      }
    },
    makeFullAddress(data) {
      let fullAddr = data.address;
      let extraAddr = '';

      if (data.addressType === 'R') {
        if (data.bname !== '') {
          extraAddr += data.bname;
        }

        if (data.buildingName !== '') {
          extraAddr +=
            extraAddr !== '' ? ', ' + data.buildingName : data.buildingName;
        }

        fullAddr += extraAddr !== '' ? ' (' + extraAddr + ')' : '';
      }

      return fullAddr;
    },
    onCenterChange(value) {
      this.coordinate = value;
      this.$emit('change', {
        address: this.value,
        coordinate: this.coordinate
      });
    }
  }
};
</script>

<style lang="scss">
.input-address-container {
  .el-input.input-address {
    width: calc(100% - 70px);
    input {
      background-color: #ffffff;
      opacity: 1 !important;
    }
  }
  .unvisible-search-address-trigger {
    position: absolute;
    width: calc(100% - 70px);
    cursor: pointer;
    height: 50px;
    top: 0;

    @media screen and (max-width: 768px) {
      top: initial;
      bottom: 0;
    }
  }

  .el-button.btn-search-address {
    margin-left: 5px;
    width: 65px;
    height: 50px;
    border-radius: 8px;
  }

  .label-description {
    line-height: 19px;
    margin: 7px 0px;
    @media screen and (max-width: 768px) {
      margin: 0 !important;
      position: relative;
      bottom: 5px;
    }
  }
}

.map-view {
  width: 100%;
  height: 217px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
}
.map-view.map-hidden {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.mobile-address-view {
  border: 1px solid;
  width: 100%;
  position: relative;
}

.mobile-address-view-container {
  height: 400px;
  overflow-y: auto;
  margin-left: -47.5px;
  margin-right: -47.5px;
  margin-bottom: 10px;
}
</style>
